
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            {/* Logo and Description */}
            <div className="text-center md:text-left">
              <div className="text-2xl font-bold mb-6" style={{ fontFamily: '"Pacifico", serif' }}>
                Oxigênio Iturama
              </div>
              <p className="text-gray-300 text-lg leading-relaxed">
                Sua empresa de confiança para entrega rápida e segura de gás de cozinha em Iturama e região.
              </p>
            </div>

            {/* Quick Links */}
            <div className="text-center">
              <h3 className="text-xl font-bold mb-6">Links Rápidos</h3>
              <ul className="space-y-3">
                <li>
                  <button 
                    onClick={() => document.getElementById('inicio')?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-gray-300 hover:text-red-400 transition-colors cursor-pointer text-lg"
                  >
                    Início
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => document.getElementById('pedido')?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-gray-300 hover:text-red-400 transition-colors cursor-pointer text-lg"
                  >
                    Fazer Pedido
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => document.getElementById('servicos')?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-gray-300 hover:text-red-400 transition-colors cursor-pointer text-lg"
                  >
                    Serviços
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-gray-300 hover:text-red-400 transition-colors cursor-pointer text-lg"
                  >
                    Contato
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="text-center md:text-right">
              <h3 className="text-xl font-bold mb-6">Contato</h3>
              <div className="space-y-4">
                <div className="flex items-center justify-center md:justify-end">
                  <i className="ri-phone-fill text-red-400 mr-3 text-xl"></i>
                  <span className="text-lg">(34) 99964-5580</span>
                </div>
                <div className="flex items-center justify-center md:justify-end">
                  <i className="ri-whatsapp-fill text-green-400 mr-3 text-xl"></i>
                  <span className="text-lg">(34) 99964-5580</span>
                </div>
                <div className="flex items-center justify-center md:justify-end">
                  <i className="ri-map-pin-fill text-blue-400 mr-3 text-xl"></i>
                  <span className="text-lg">Iturama - MG</span>
                </div>
                <div className="flex items-center justify-center md:justify-end">
                  <i className="ri-time-fill text-red-400 mr-3 text-xl"></i>
                  <span className="text-lg">Das 8h às 18h</span>
                </div>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="bg-gradient-to-r from-red-600 to-blue-600 rounded-3xl p-8 mb-12 text-center">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              Precisa de Gás Agora?
            </h3>
            <p className="text-lg mb-6 max-w-2xl mx-auto">
              Faça seu pedido e receba em minutos!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => document.getElementById('pedido')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-white text-red-600 px-8 py-4 rounded-full font-bold hover:bg-gray-100 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl"
              >
                <i className="ri-shopping-cart-fill mr-2"></i>
                FAZER PEDIDO
              </button>
              <a 
                href="https://wa.me/5534999645580?text=Olá! Gostaria de fazer um pedido de gás de cozinha."
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-600 text-white px-8 py-4 rounded-full font-bold hover:bg-green-7

transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl"
              >
                <i className="ri-whatsapp-fill mr-2"></i>
                WHATSAPP
              </a>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-700 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="text-gray-400 text-center md:text-left mb-4 md:mb-0">
                <p className="mb-1">© 2024 Oxigênio Iturama Ltda. Todos os direitos reservados.</p>
                <p className="text-sm">CNPJ: 00.570.301/0001-50</p>
                <p className="text-sm">Av. Marginal José Simeão de Queiroz, 141 - Iturama/MG - CEP: 38.280-000</p>
              </div>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
